module.exports = __webpack_public_path__ + "static/media/details-18-image-3.7ff94887.jpg";